import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box } from '@hub/box';
import SearchInput from './search-input';
import ResultsPanel from './results-panel';
import QuitButton from './quit-button';
import { useMediaQuery } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SearchForm = _ref => {
  let {
    refsAndCursor,
    autocomplete,
    placeholder,
    query,
    clearQuery,
    collections,
    context,
    onClickClose,
    reinitialiseQuery,
    setNonDebouncedQuery
  } = _ref;
  const {
    autocompleteRefs
  } = refsAndCursor;
  const searchWidth = 584; // We want the margin in place until there's sufficient
  // space from the outer container that we don't need it

  const mediaQuery = "(max-width: ".concat(searchWidth + 16, "px");
  const [isLessWide] = useMediaQuery(mediaQuery);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: '100%',
      height: '100%',
      margin: 'auto'
    },
    "data-id": "search-modal-autocomplete_search-form_SearchForm_Box",
    children: [/*#__PURE__*/_jsx(QuitButton, {
      sx: {
        display: ['initial', 'initial', 'none'],
        padding: 'spacing-none',
        marginRight: isLessWide ? 'spacing-md' : 'spacing-none',
        marginLeft: 'spacing-none',
        marginTop: 'spacing-none',
        marginBottom: 'spacing-none',
        minWidth: 'size-xs',
        float: 'right'
      },
      onClickClose: onClickClose,
      "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_QuitButton"
    }), /*#__PURE__*/_jsx(Box, {
      maxWidth: searchWidth,
      "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_Box",
      children: /*#__PURE__*/_jsxs("form", _objectSpread(_objectSpread({
        ref: autocompleteRefs.formRef
      }, autocomplete.getFormProps(autocompleteRefs.getElems())), {}, {
        "data-id": "search-modal-autocomplete_search-form_SearchForm_Box_form",
        children: [/*#__PURE__*/_jsx(SearchInput, {
          onClickClose,
          refsAndCursor,
          autocomplete,
          placeholder,
          query,
          clearQuery,
          reinitialiseQuery,
          setNonDebouncedQuery,
          "data-id": "search-modal-autocomplete_search-form_SearchForm_form_SearchInput"
        }), /*#__PURE__*/_jsx(ResultsPanel, {
          context,
          refsAndCursor,
          autocomplete,
          query,
          collections,
          "data-id": "search-modal-autocomplete_search-form_SearchForm_form_ResultsPanel"
        })]
      }))
    })]
  });
};

export default SearchForm;